import React from 'react';
import { Row, Col } from 'reactstrap';

/* eslint-disable */
const ViewEssayQuestionChoices = (props) => {
  const {
    development_justification = '',
    setJustification,
    is_multiple,
    is_development,
    justification2 = '',
    justification1 = '',
    userChoice,
    justification,
    disabledTextArea,
    clickOption,
    selectedCaseQuestionData,
    disabledChoices,
  } = props;
  let choices = [];
  for (const objKey in props)
    if (objKey.includes('choice'))
      if (props[objKey]) choices.push(props[objKey]);
  console.log(
    'userChoice[selectedCaseQuestionData.id]',
    userChoice[selectedCaseQuestionData.id]
  );
  return (
    <Row>
      {development_justification && development_justification.includes('&;') ? (
        <Col className={` rounded p-1`} md='12' xs='12' sm='12'>
          <b>{development_justification.split('&;')[0].split(':')[0]} :</b>
          <input
            type='text'
            className='border-0 w-50 view_questionhtml'
            placeholder='Please write your answer'
          />
        </Col>
      ) : null}
      {choices.length || development_justification.includes('&;') ? (
        <Col xs='12' md={development_justification.includes('&;') ? '12' : '3'}>
          <div
            className={`${
              development_justification.includes('&;')
                ? 'justify-content-around'
                : 'flex-column'
            }  d-flex border ${is_multiple ? 'rounded mb-sm-1 mb-md-0' : ''} `}
          >
            {/* ------------------------------------- */}
            {choices.map((choice, index) => (
              <div
                className={`answer_box ${
                  userChoice[selectedCaseQuestionData.id] ===
                  `choice_${String.fromCharCode(index + 97)}`
                    ? `border-yellow`
                    : 'border-black'
                }`}
              >
                <p
                  className='ans_box_text tooltip_wrap ml-0'
                  onClick={(e) => {
                    !disabledChoices &&
                      clickOption(
                        `choice_${String.fromCharCode(index + 97)}`,
                        selectedCaseQuestionData && selectedCaseQuestionData.id
                          ? selectedCaseQuestionData.id
                          : null,
                        selectedCaseQuestionData,
                        e
                      );
                  }}
                >
                  <span class='no-selection' contenteditable='false'>
                    {choice}
                  </span>
                </p>
              </div>
            ))}
            {/* ------------------------------------ */}
            {/* {choices.map((choice, index) => (
                <div
                  key={index}
                  className={`d-flex align-items-center pointer_class sidebar_item ${
                    is_multiple ? 'border-0' : 'border-gray rounded'
                  } ${selectedIndex === index ? 'clicked_box' : ''} ${
                    showResult &&
                    selectedChoice === choice &&
                    selectedChoice !== multiple_answer
                      ? 'failure text-white'
                      : ''
                  } ${
                    showResult && choice === multiple_answer
                      ? 'success text-white'
                      : ''
                  }`}
                  name='selectedChoice'
                  onClick={() => !showResult && setUserChoice(choice, index)}
                >
                  <span>{choice}</span>
                </div>
              ))} */}
          </div>
        </Col>
      ) : null}
      <Col
        xs='12'
        md={
          development_justification.includes('&;') ||
          (is_development && !choices.length)
            ? '12'
            : '9 pl-md-0'
        }
        className={`${
          development_justification.includes('&;') ||
          (is_development && !choices.length)
            ? ''
            : ''
        } `}
      >
        {is_development ? (
          is_multiple ? (
            <textarea
              className='w-100 h-100 view_questionhtml'
              placeholder='Write your justification here'
              onChange={(e) => {
                setJustification(e);
              }}
              disabled={disabledTextArea}
              value={
                justification1 ||
                (justification[selectedCaseQuestionData.id] &&
                  justification[selectedCaseQuestionData.id][
                    'justification1'
                  ]) ||
                ''
              }
              name='justification1'
            />
          ) : choices.length ? (
            choices.map((choice, index) => (
              <div className='h-100p'>
                <textarea
                  placeholder='Write your justification here'
                  className='w-100 h-100 min-height-150 view_questionhtml'
                  onChange={(e) => {
                    setJustification(e);
                  }}
                  disabled={disabledTextArea}
                  value={
                    props[`justification${index + 1}`] ||
                    (justification[selectedCaseQuestionData.id] &&
                      justification[selectedCaseQuestionData.id][
                        `justification${index + 1}`
                      ]) ||
                    ''
                  }
                  name={[`justification${index + 1}`]}
                />
              </div>
            ))
          ) : (
            <textarea
              className='w-100 h-100 min-height-150 view_questionhtml'
              placeholder='Write your justification here'
              onChange={(e) => {
                setJustification(e);
              }}
              disabled={disabledTextArea}
              value={
                justification1 ||
                (justification[selectedCaseQuestionData.id] &&
                  justification[selectedCaseQuestionData.id][
                    'justification1'
                  ]) ||
                ''
              }
              name='justification1'
            />
          )
        ) : null}
      </Col>
    </Row>
  );
};

export default ViewEssayQuestionChoices;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/FinishTest/ViewEssayQuestionChoices.jsx